

const accountPayable          = require ('./provider-report-account-payable')
const accountPayableAll       = require ('./provider-report-account-payable-all')
const profitsAll              = require ('./provider-report-all-profit')
const profitPeriod            = require ('./provider-report-profit-period')

export function start(detail){  
         
      obj[detail.reportType].start(detail)

}/**/

const obj = {
   
      accountPayable:     { start: (detail)=>{  accountPayable.start(detail)     }},
      accountPayableAll:  { start: (detail)=>{  accountPayableAll.start(detail)  }},
      profitPeriod:       { start: (detail)=>{  profitPeriod.start(detail)       }},
      profitsAll:         { start: (detail)=>{  profitsAll.start(detail)         }},

}


